import React from 'react'
import Header from '../components/header'
import Routers from '../routers/route'
import Footer from '../components/footer'

function Layout() {
  return (
    <div>
      <>
      <Header/>
      <Routers/>
      <Footer/>
      
      </>
    </div>
  )
}

export default Layout
